import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/Users/brandonwu/Documents/PTS/Gatsby/Instana-1-Day-Partner-Workshop/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const Title = () => <span>
    Instana Workshop Presentations <br />
  </span>;
;
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const ArticleCard = makeShortcode("ArticleCard");
const layoutProps = {
  Title,
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Row mdxType="Row">
      <Column colMd={4} colLg={4} noGutterMdLeft mdxType="Column">
        <ArticleCard title="Instana Overview" href="https://ibm.box.com/s/0pgzj81cbkmg6jv6moidoxhbgjnfxlna" actionIcon="arrowRight" mdxType="ArticleCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "62.15277777777778%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAABYlAAAWJQFJUiTwAAABy0lEQVQoz31TyW7UQBBtiW+EExJ3xIkbv8AfkAMjpCBFCHFKAgKkzAGwNZcww5bFkWeBiSf2hJl46b0f6m7HsUcRJbW6qrvqvarnNkHLjDEwbd/4iCmFeC2wZrpzd5PtTqGNAZEAnmcptn7P3LG+Tm4BJlTgT8WQCNEA6hrr3RHHwx7DLPMxeTyd4M7H97j3qQ/kf5sCv3vmEsrtBtIRWhPSnmm8Hma4v73Ej9jGEuTR6TGeRCcYxWc4HA27I9XFu78kHuxQHE7RECmlcFVUqIocjOYoywJSKhCrj7WvgxAvtl86n0sFqQ2UMUizAs8Ga9w9yLATLDBfLJxyUmlHyIUEZbxRkugaMB5PEIShBxTCFSltMIpSHI8TnIwn2PscYHAUea212ZDHT0SkUigr6kCqimJ9lXtAAwhlME1WGPw8x96X73jTDxHPk6YbznkH1HV47TDGUVHaYbQd2rXKK3yLpkgvV04Ka1u9VwiCAOfzWbfDNnr7Pd749apjq6ud6jQ6w9v9Pnb3D2oJvKZk86tuauKeS/vOGCeRtae9IT6Ec09Ud05wy59xm9+OrdZ5UeIiXWB5uURFWUNM8B9rg2xKYd8c4wJK607+P7C9mlr1dIsTAAAAAElFTkSuQmCC')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Quoting and Licensing",
              "title": "Quoting and Licensing",
              "src": "/Instana-1-Day-Partner-Workshop/static/9abda0a0c94eab405323b37375f75848/3cbba/InstanaImage.png",
              "srcSet": ["/Instana-1-Day-Partner-Workshop/static/9abda0a0c94eab405323b37375f75848/7fc1e/InstanaImage.png 288w", "/Instana-1-Day-Partner-Workshop/static/9abda0a0c94eab405323b37375f75848/a5df1/InstanaImage.png 576w", "/Instana-1-Day-Partner-Workshop/static/9abda0a0c94eab405323b37375f75848/3cbba/InstanaImage.png 1152w", "/Instana-1-Day-Partner-Workshop/static/9abda0a0c94eab405323b37375f75848/84b04/InstanaImage.png 1359w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy",
              "decoding": "async"
            }}></img>{`
    `}</span>
        </ArticleCard>
      </Column>
      <Column colMd={4} colLg={4} noGutterMdLeft mdxType="Column">
        <ArticleCard title="Instana Pre-Sales and POC Overview" href="https://ibm.box.com/s/end6wuwyfim3o27yo2eemztv8lnnmlrt" actionIcon="arrowRight" mdxType="ArticleCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "62.15277777777778%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAABYlAAAWJQFJUiTwAAABy0lEQVQoz31TyW7UQBBtiW+EExJ3xIkbv8AfkAMjpCBFCHFKAgKkzAGwNZcww5bFkWeBiSf2hJl46b0f6m7HsUcRJbW6qrvqvarnNkHLjDEwbd/4iCmFeC2wZrpzd5PtTqGNAZEAnmcptn7P3LG+Tm4BJlTgT8WQCNEA6hrr3RHHwx7DLPMxeTyd4M7H97j3qQ/kf5sCv3vmEsrtBtIRWhPSnmm8Hma4v73Ej9jGEuTR6TGeRCcYxWc4HA27I9XFu78kHuxQHE7RECmlcFVUqIocjOYoywJSKhCrj7WvgxAvtl86n0sFqQ2UMUizAs8Ga9w9yLATLDBfLJxyUmlHyIUEZbxRkugaMB5PEIShBxTCFSltMIpSHI8TnIwn2PscYHAUea212ZDHT0SkUigr6kCqimJ9lXtAAwhlME1WGPw8x96X73jTDxHPk6YbznkH1HV47TDGUVHaYbQd2rXKK3yLpkgvV04Ka1u9VwiCAOfzWbfDNnr7Pd749apjq6ud6jQ6w9v9Pnb3D2oJvKZk86tuauKeS/vOGCeRtae9IT6Ec09Ud05wy59xm9+OrdZ5UeIiXWB5uURFWUNM8B9rg2xKYd8c4wJK607+P7C9mlr1dIsTAAAAAElFTkSuQmCC')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Instana Intro",
              "title": "Instana Intro",
              "src": "/Instana-1-Day-Partner-Workshop/static/9abda0a0c94eab405323b37375f75848/3cbba/InstanaImage.png",
              "srcSet": ["/Instana-1-Day-Partner-Workshop/static/9abda0a0c94eab405323b37375f75848/7fc1e/InstanaImage.png 288w", "/Instana-1-Day-Partner-Workshop/static/9abda0a0c94eab405323b37375f75848/a5df1/InstanaImage.png 576w", "/Instana-1-Day-Partner-Workshop/static/9abda0a0c94eab405323b37375f75848/3cbba/InstanaImage.png 1152w", "/Instana-1-Day-Partner-Workshop/static/9abda0a0c94eab405323b37375f75848/84b04/InstanaImage.png 1359w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy",
              "decoding": "async"
            }}></img>{`
    `}</span>
        </ArticleCard>
      </Column>
      <Column colMd={4} colLg={4} noGutterMdLeft mdxType="Column">
        <ArticleCard title="Instana Customer Success" href="https://ibm.box.com/s/2al7owmtr730no3ptm2dfiifmik2rch6" actionIcon="arrowRight" mdxType="ArticleCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "62.15277777777778%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAABYlAAAWJQFJUiTwAAABy0lEQVQoz31TyW7UQBBtiW+EExJ3xIkbv8AfkAMjpCBFCHFKAgKkzAGwNZcww5bFkWeBiSf2hJl46b0f6m7HsUcRJbW6qrvqvarnNkHLjDEwbd/4iCmFeC2wZrpzd5PtTqGNAZEAnmcptn7P3LG+Tm4BJlTgT8WQCNEA6hrr3RHHwx7DLPMxeTyd4M7H97j3qQ/kf5sCv3vmEsrtBtIRWhPSnmm8Hma4v73Ej9jGEuTR6TGeRCcYxWc4HA27I9XFu78kHuxQHE7RECmlcFVUqIocjOYoywJSKhCrj7WvgxAvtl86n0sFqQ2UMUizAs8Ga9w9yLATLDBfLJxyUmlHyIUEZbxRkugaMB5PEIShBxTCFSltMIpSHI8TnIwn2PscYHAUea212ZDHT0SkUigr6kCqimJ9lXtAAwhlME1WGPw8x96X73jTDxHPk6YbznkH1HV47TDGUVHaYbQd2rXKK3yLpkgvV04Ka1u9VwiCAOfzWbfDNnr7Pd749apjq6ud6jQ6w9v9Pnb3D2oJvKZk86tuauKeS/vOGCeRtae9IT6Ec09Ud05wy59xm9+OrdZ5UeIiXWB5uURFWUNM8B9rg2xKYd8c4wJK607+P7C9mlr1dIsTAAAAAElFTkSuQmCC')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Instana Intro",
              "title": "Instana Intro",
              "src": "/Instana-1-Day-Partner-Workshop/static/9abda0a0c94eab405323b37375f75848/3cbba/InstanaImage.png",
              "srcSet": ["/Instana-1-Day-Partner-Workshop/static/9abda0a0c94eab405323b37375f75848/7fc1e/InstanaImage.png 288w", "/Instana-1-Day-Partner-Workshop/static/9abda0a0c94eab405323b37375f75848/a5df1/InstanaImage.png 576w", "/Instana-1-Day-Partner-Workshop/static/9abda0a0c94eab405323b37375f75848/3cbba/InstanaImage.png 1152w", "/Instana-1-Day-Partner-Workshop/static/9abda0a0c94eab405323b37375f75848/84b04/InstanaImage.png 1359w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy",
              "decoding": "async"
            }}></img>{`
    `}</span>
        </ArticleCard>
      </Column>
      <Column colMd={4} colLg={4} noGutterMdLeft mdxType="Column">
        <ArticleCard title="Instana Competitive Info" href="https://ibm.box.com/s/zjoq3nya7miu3xl6nl9t1mzufg0gh6ol" actionIcon="arrowRight" mdxType="ArticleCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "62.15277777777778%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAABYlAAAWJQFJUiTwAAABy0lEQVQoz31TyW7UQBBtiW+EExJ3xIkbv8AfkAMjpCBFCHFKAgKkzAGwNZcww5bFkWeBiSf2hJl46b0f6m7HsUcRJbW6qrvqvarnNkHLjDEwbd/4iCmFeC2wZrpzd5PtTqGNAZEAnmcptn7P3LG+Tm4BJlTgT8WQCNEA6hrr3RHHwx7DLPMxeTyd4M7H97j3qQ/kf5sCv3vmEsrtBtIRWhPSnmm8Hma4v73Ej9jGEuTR6TGeRCcYxWc4HA27I9XFu78kHuxQHE7RECmlcFVUqIocjOYoywJSKhCrj7WvgxAvtl86n0sFqQ2UMUizAs8Ga9w9yLATLDBfLJxyUmlHyIUEZbxRkugaMB5PEIShBxTCFSltMIpSHI8TnIwn2PscYHAUea212ZDHT0SkUigr6kCqimJ9lXtAAwhlME1WGPw8x96X73jTDxHPk6YbznkH1HV47TDGUVHaYbQd2rXKK3yLpkgvV04Ka1u9VwiCAOfzWbfDNnr7Pd749apjq6ud6jQ6w9v9Pnb3D2oJvKZk86tuauKeS/vOGCeRtae9IT6Ec09Ud05wy59xm9+OrdZ5UeIiXWB5uURFWUNM8B9rg2xKYd8c4wJK607+P7C9mlr1dIsTAAAAAElFTkSuQmCC')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Instana Intro",
              "title": "Instana Intro",
              "src": "/Instana-1-Day-Partner-Workshop/static/9abda0a0c94eab405323b37375f75848/3cbba/InstanaImage.png",
              "srcSet": ["/Instana-1-Day-Partner-Workshop/static/9abda0a0c94eab405323b37375f75848/7fc1e/InstanaImage.png 288w", "/Instana-1-Day-Partner-Workshop/static/9abda0a0c94eab405323b37375f75848/a5df1/InstanaImage.png 576w", "/Instana-1-Day-Partner-Workshop/static/9abda0a0c94eab405323b37375f75848/3cbba/InstanaImage.png 1152w", "/Instana-1-Day-Partner-Workshop/static/9abda0a0c94eab405323b37375f75848/84b04/InstanaImage.png 1359w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy",
              "decoding": "async"
            }}></img>{`
    `}</span>
        </ArticleCard>
      </Column>
      <Column colMd={4} colLg={4} noGutterMdLeft mdxType="Column">
        <ArticleCard title="Instana Updates and Roadmap" href="https://ibm.box.com/s/robukuatc1qm3lsgiv51h762wbogn9g3" actionIcon="arrowRight" mdxType="ArticleCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "62.15277777777778%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAABYlAAAWJQFJUiTwAAABy0lEQVQoz31TyW7UQBBtiW+EExJ3xIkbv8AfkAMjpCBFCHFKAgKkzAGwNZcww5bFkWeBiSf2hJl46b0f6m7HsUcRJbW6qrvqvarnNkHLjDEwbd/4iCmFeC2wZrpzd5PtTqGNAZEAnmcptn7P3LG+Tm4BJlTgT8WQCNEA6hrr3RHHwx7DLPMxeTyd4M7H97j3qQ/kf5sCv3vmEsrtBtIRWhPSnmm8Hma4v73Ej9jGEuTR6TGeRCcYxWc4HA27I9XFu78kHuxQHE7RECmlcFVUqIocjOYoywJSKhCrj7WvgxAvtl86n0sFqQ2UMUizAs8Ga9w9yLATLDBfLJxyUmlHyIUEZbxRkugaMB5PEIShBxTCFSltMIpSHI8TnIwn2PscYHAUea212ZDHT0SkUigr6kCqimJ9lXtAAwhlME1WGPw8x96X73jTDxHPk6YbznkH1HV47TDGUVHaYbQd2rXKK3yLpkgvV04Ka1u9VwiCAOfzWbfDNnr7Pd749apjq6ud6jQ6w9v9Pnb3D2oJvKZk86tuauKeS/vOGCeRtae9IT6Ec09Ud05wy59xm9+OrdZ5UeIiXWB5uURFWUNM8B9rg2xKYd8c4wJK607+P7C9mlr1dIsTAAAAAElFTkSuQmCC')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Instana Intro",
              "title": "Instana Intro",
              "src": "/Instana-1-Day-Partner-Workshop/static/9abda0a0c94eab405323b37375f75848/3cbba/InstanaImage.png",
              "srcSet": ["/Instana-1-Day-Partner-Workshop/static/9abda0a0c94eab405323b37375f75848/7fc1e/InstanaImage.png 288w", "/Instana-1-Day-Partner-Workshop/static/9abda0a0c94eab405323b37375f75848/a5df1/InstanaImage.png 576w", "/Instana-1-Day-Partner-Workshop/static/9abda0a0c94eab405323b37375f75848/3cbba/InstanaImage.png 1152w", "/Instana-1-Day-Partner-Workshop/static/9abda0a0c94eab405323b37375f75848/84b04/InstanaImage.png 1359w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy",
              "decoding": "async"
            }}></img>{`
    `}</span>
        </ArticleCard>
      </Column>
      <Column colMd={4} colLg={4} noGutterMdLeft mdxType="Column">
        <ArticleCard title="Instana Partner Pricing" href="https://ibm.box.com/s/22ng4ree7ehih5mnev3yd9b7oim3rv60" actionIcon="arrowRight" mdxType="ArticleCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "62.15277777777778%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAABYlAAAWJQFJUiTwAAABy0lEQVQoz31TyW7UQBBtiW+EExJ3xIkbv8AfkAMjpCBFCHFKAgKkzAGwNZcww5bFkWeBiSf2hJl46b0f6m7HsUcRJbW6qrvqvarnNkHLjDEwbd/4iCmFeC2wZrpzd5PtTqGNAZEAnmcptn7P3LG+Tm4BJlTgT8WQCNEA6hrr3RHHwx7DLPMxeTyd4M7H97j3qQ/kf5sCv3vmEsrtBtIRWhPSnmm8Hma4v73Ej9jGEuTR6TGeRCcYxWc4HA27I9XFu78kHuxQHE7RECmlcFVUqIocjOYoywJSKhCrj7WvgxAvtl86n0sFqQ2UMUizAs8Ga9w9yLATLDBfLJxyUmlHyIUEZbxRkugaMB5PEIShBxTCFSltMIpSHI8TnIwn2PscYHAUea212ZDHT0SkUigr6kCqimJ9lXtAAwhlME1WGPw8x96X73jTDxHPk6YbznkH1HV47TDGUVHaYbQd2rXKK3yLpkgvV04Ka1u9VwiCAOfzWbfDNnr7Pd749apjq6ud6jQ6w9v9Pnb3D2oJvKZk86tuauKeS/vOGCeRtae9IT6Ec09Ud05wy59xm9+OrdZ5UeIiXWB5uURFWUNM8B9rg2xKYd8c4wJK607+P7C9mlr1dIsTAAAAAElFTkSuQmCC')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Instana Intro",
              "title": "Instana Intro",
              "src": "/Instana-1-Day-Partner-Workshop/static/9abda0a0c94eab405323b37375f75848/3cbba/InstanaImage.png",
              "srcSet": ["/Instana-1-Day-Partner-Workshop/static/9abda0a0c94eab405323b37375f75848/7fc1e/InstanaImage.png 288w", "/Instana-1-Day-Partner-Workshop/static/9abda0a0c94eab405323b37375f75848/a5df1/InstanaImage.png 576w", "/Instana-1-Day-Partner-Workshop/static/9abda0a0c94eab405323b37375f75848/3cbba/InstanaImage.png 1152w", "/Instana-1-Day-Partner-Workshop/static/9abda0a0c94eab405323b37375f75848/84b04/InstanaImage.png 1359w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy",
              "decoding": "async"
            }}></img>{`
    `}</span>
        </ArticleCard>
      </Column>
    </Row>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      